<template>
  <div>
    <!--Breadcrumb button-->
    <breadcrumb-button>
      <template #beforeDropdown>
        <b-button
            variant="success"
            class="btn-icon position-relative"
            v-b-tooltip
            v-bind:title="$t('operations.add')"
            @click="onBrandSelected(null)"
        >
          <i class="fa-solid fa-bullhorn"></i>
          <i
              class="fa-solid fa-plus position-absolute"
              style="font-size: 0.6em; top: 14px; right: 1px;"
          ></i>
        </b-button>
      </template>
      <template #items>
        <b-dropdown-item @click="openColumnsModal">
          <feather-icon
              icon="CheckSquareIcon"
              size="16"
          />
          <span class="align-middle ml-50">{{ $t('columns.self') }}</span>
        </b-dropdown-item>
      </template>
    </breadcrumb-button>

    <!--Filters-->
    <filter-card v-model="filter" v-bind:fields="filterFields" search/>

    <!-- Tabs with tables -->
    <b-card no-body>
      <b-card-header class="pb-50">
        <h5>{{ $t("menu.brands") }}</h5>
      </b-card-header>
      <b-card-body>
        <brands-table
            ref="brandTable1"
            v-bind:filters="filter"
            v-bind:columns="columns"
            :has-selection="false"
            @selected="onBrandSelected"
            :lazy="true"
        />

      </b-card-body>
    </b-card>

    <!--Modal-->
    <columns-modal ref="columns-modal" column-key="brands" v-model="columns"
                   v-bind:columns-names="columnsNames" />
    <brand-modal ref="brand-modal" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BreadcrumbButton from '@/components/widget/breadcrumbButton'
import BrandSearchRequest from '@/model/brand/BrandSearchRequest'
import ColumnsModal from '@/components/modal/columnsModal'
import Brand from '@/model/brand/Brand'
import mixinPermissions from '@/components/mixin/mixinPermissions'
import mixinBase from '@/components/mixin/mixinBase'
import BrandModal from '@/components/modal/brandModal'
import FilterCard from '@/components/widget/FilterCard'
import BrandFilterFields from '@/model/filter/BrandFilterFields'
import BrandsTable from '@/components/tables/BrandsTable'

export default {
  name: 'BrandsView',
  components: {
    BrandsTable,
    FilterCard,
    BrandModal,
    ColumnsModal,
    BreadcrumbButton
  },
  mixins: [mixinBase, mixinPermissions],
  data() {
    return {
      columnsNames: Object.keys(Brand()),
      filter: BrandSearchRequest(),
      filterLoaded: false,
      columns: [],
      filterFields: null,
    }
  },
  async created() {
    await this.refreshData()
    this.filterFields = BrandFilterFields()
  },
  computed: {
    ...mapGetters('data', ['allOrganizations']),
  },
  methods: {
    ...mapActions('brand', ['refreshData']),
    openColumnsModal() {
      this.$refs['columns-modal'].showModal()
    },
    onBrandSelected(selectedId) {
      this.$refs['brand-modal'].showModal(selectedId)
    },
  }
}
</script>
